// import index from "@/views/MapIndex.vue"
// import BackManage from "@/views/BackManage.vue"
// import BackLogin from "@/views/BackLogin.vue"

// import user from "@/views/manage/UserInfo.vue"
// import log from "@/views/manage/LogMan.vue"
// import data from "@/views/manage/DataMan.vue"
// import permission from "@/views/manage/PermiSsion.vue"

export default [
  {
    path: "/",
    name: "homeIndex",
    component: () => import(/* webpackChunkName: "HomeIndex" */ '../../views/HomeIndex/HomeIndex.vue'),
    redirect: '/mapView',
    children: [
      {
        path: '/mapView',
        name: 'mapView',
        component: () => import(/* webpackChunkName: "MapView" */ '../../views/MapView/MapView.vue'),
      },
      {
        path: '/constructionUnit',
        name: 'constructionUnit',
        component: () => import(/* webpackChunkName: "ConstructionUnit" */ '../../views/ConstructionUnitManager/ConstructionUnitManager.vue'),
        // redirect: '/constructionUnit/constructionTaskList',
        // children: [
        //   {
        //     path: 'constructionTaskList',
        //     name: 'constructionTaskList',
        //     component: () => import(/* webpackChunkName: "ConstructionTaskList" */ '../../views/ConstructionUnitManager/Children/ConstructionTaskList/ConstructionTaskList.vue'),
        //   },
        //   {
        //     path: 'constructionTeamList',
        //     name: 'constructionTeamList',
        //     component: () => import(/* webpackChunkName: "ConstructionTeamList" */ '../../views/ConstructionUnitManager/Children/ConstructionTeamList/ConstructionTeamList.vue'),
        //   }
        // ]
      },
      {
        path: '/dataManager',
        name: 'dataManager',
        component: () => import(/* webpackChunkName: "DataManager" */ '../../views/DataManager/DataManager.vue'),
      },
      {
        path: '/logBrowse',
        name: 'logBrowse',
        component: () => import(/* webpackChunkName: "LogBrowse" */ '../../views/LogBrowse/LogBrowse.vue'),
      },
      {
        path: '/constructionManager',
        name: 'constructionManager',
        component: () => import(/* webpackChunkName: "ConstructionManager" */ '../../views/Construction/ConstructionManager/ConstructionManager.vue'),
      },
      {
        path: '/constructionReport',
        name: 'constructionReport',
        component: () => import(/* webpackChunkName: "ConstructionReport" */ '../../views/Construction/ConstructionReport/ConstructionReport.vue'),
      },
      {
        path: '/constructionTask',
        name: 'constructionTask',
        component: () => import(/* webpackChunkName: "ConstructionTask" */ '../../views/Construction/ConstructionTask/ConstructionTask.vue'),
      },
    ]
  },
  {
    path: "/login",
    name: "login",
    component: () => import(/* webpackChunkName: "LogBrowse" */ '../../views/Login/LoginView.vue'),
  },
  {
    path: "/workModule",
    name: "workModule",
    component: () => import(/* webpackChunkName: "WorkModule" */ '../../views/WorkModule/WorkModule.vue'),
  },
]